<template>
  <div class="studycard-manage">
    <div>
      <Button type="primary" @click="onAdd" class="btn-margin-right com-margin-top">新增学习卡</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/studyCard"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="c1">{{row.used_number}}/{{row.card_number}}</template>
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onExport(row)">导出</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onWatch(row)">查看</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onStop(row)" v-if="row.status==1">停用</Button>
            <Button type="text" size="small" disabled v-else-if="row.status==0">已停用</Button>
            <Button type="text" size="small" disabled v-else-if="row.status==2">已过期</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onRecord(row)">兑换记录</Button>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>

<script>
export default {
  name: 'studycard-manage',
  data() {
    return {
      searchCondition: {},
      tableColumns: [
        { title: '学习卡批次名称', key: 'name' },
        { title: '学习卡内容', key: 'courses', align: 'center' },
        { title: '面额', key: 'price', align: 'center' },
        { title: '失效日期', key: 'expired_at', align: 'center' },
        { title: '使用/发放', slot: 'c1', align: 'center' },
        { title: '操作', slot: 'action', align: 'center' }
      ]
    }
  },
  methods: {
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.price = (i.price / 100).toFixed(2)
        i.expired_at = this.$pub.timestampToTime(i.expired_at)
      })
    },
    onAdd() {
      this.$router.push({
        name: 'StudyCardEdit'
      })
    },
    onExport(row) {
      this.$http.get('/api/export/studyCard/' + row.id).then(data => {
        window.open(data.url)
      })
    },
    onWatch(row) {
      this.$router.push({
        name: 'StudyCardEdit',
        query: {
          id: row.id
        }
      })
    },
    onStop(row) {
      this.$Modal.confirm({
        title: '提示',
        content:
          '<p>停用后本批次的卡不能再进行兑换，已经兑换的不受影响。</p><p>停用后的卡不可以重新启用。</p><p>确定停用吗？</p>',
        width: 500,
        onOk: () => {
          this.$http.put('/api/studyCard/on/' + row.id).then(() => {
            this.$Message.success('停用成功')
            this.$refs.grid.refresh()
          })
        }
      })
    },
    onRecord(row) {
      this.$router.push({
        name: 'StudyCardRecord',
        query: {
          id: row.id
        }
      })
    }
  }
}
</script>